<template>
  <div :class="['scrollBanner', (!show || manualClose) ? 'pointer' : '']">
    <div
      class="scroll_con animated"
      :class="{
        fadeInUp: show && !manualClose,
        fadeOutDown: !show || manualClose,
      }"
    >
      <div class="big-elephant">
        <img
          src="https://asset.tsign.cn/apps/esign-nuxt-website/prod/1.0.9/img/8aeb8ee.svg"
          alt="关闭按钮"
          class="close-btn"
          @click="manualClose = true"
        />
        <img class="esign-elephant" src="https://asset.tsign.cn/apps/esign-nuxt-website/prod/1.0.9/img/0ec1e51.png" />
      </div>
      <input
        :class="[(isClick && name == '') || name == '请输入您的姓名(中文)' ? 'active_input' : '']"
        v-model="name"
        type="text"
        placeholder="您的姓名"
        @focus="clearData(0)"
        @blur="onfousFun()"
      />
      <input
        :class="[(isClick && companyName == '') || companyName == '请输入公司名称(中文)' ? 'active_input' : '']"
        v-model="companyName"
        type="text"
        placeholder="公司名称"
        @focus="clearData(1)"
        @blur="onfousFun()"
      />
      <input
        :class="[(isClick && phoneNumber == '') || phoneNumber == '请输入您的联系方式' ? 'active_input' : '']"
        v-model="phoneNumber"
        type="text"
        placeholder="手机号码"
        @focus="clearData(2)"
        @blur="onfousFun()"
      />
      <input
        :class="[(isClick && phoneCode == '') || phoneCode == '请输入验证码' ? 'active_input last' : 'last']"
        v-model="phoneCode"
        maxlength="6"
        class="send_code"
        placeholder="验证码"
        @focus="clearData(3)"
        @blur="onfousFun()"
      />
      <div :class="[codeName == '获取验证码' ? 'active_c1' : 'active_c']" class="send_code_tx" @click="handleFetchCodeClick()">
        {{ codeName }}
      </div>
      <div id="man-machine-slide"></div>
      <div class="try_button" @click="handleSendInfoBtnClick" data-agl-cvt="5">提交试用信息</div>
      <img
        class="small-elephant animated"
        :class="{
          fadeInUp: show && manualClose,
          fadeOutDown: !show && manualClose,
        }"
        v-show="manualClose"
        src="https://asset.tsign.cn/apps/esign-nuxt-website/prod/1.0.9/img/5e6efc7.png"
        @click="manualClose = false"
      />
    </div>
  </div>
</template>

<script>
import formMixin from '../mixins/form.js'

export default {
  props: {
    show: Boolean,
    landingPageName: String,
  },
  mixins: [formMixin],
  data() {
    return {
      manualClose: false,
      closeForm: true,
    }
  },
  watch: {
    closeForm(v, oldV) {
      this.$emit('setShowSuccessDialog', !v)
    },
  },
}
</script>

<style lang="less" scoped>
.scrollBanner {
  height: 3.7333rem;
  width: 100%;
  bottom: 0;
  left: 0;
  text-align: center;
  z-index: 11;
  position: fixed;
  overflow: auto;
  // min-width: 1200px;

  .big-elephant {
    display: flex;
    align-items: flex-start;
  }

  .small-elephant {
    position: absolute;
    bottom: .16rem;
    right: -2.6667rem;
    width: 2.6667rem;
    cursor: pointer;
  }

  .esign-elephant {
    width: 4.9867rem;
  }

  .close-btn {
    width: .6933rem;
    height: .6933rem;
    transform: rotateZ(0);
    transition: transform 0.5s;
    cursor: pointer;

    &:hover {
      transform: rotateZ(90deg);
    }
  }

  .scroll_title {
    width: 32rem;
    font-size: .8rem;
    color: #fff;
    text-align: center;
    padding-top: .8rem;
    margin: auto;
  }

  .scroll_con {
    margin: 0;
    padding: 0 .2667rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    background: #000;
    width: 100%;
  }

  .warning-info {
    padding-left: 10.6667rem;
    font-size: .32rem;
    color: #e61717;
  }

  input {
    background: #fff;
    outline: 0;
    border: 0;
    border-radius: .08rem;
    width: 5.3333rem;
    height: 1.28rem;
    padding-left: .4rem;
    margin-left: .32rem;

    &::placeholder {
      padding-left: .4rem;
      color: #333;
    }

    &::-webkit-input-placeholder {
      padding-left: .4rem;
      color: #333;
    }

    &::-moz-placeholder {
      padding-left: .4rem;
      color: #333;
    }

    &:-moz-placeholder {
      padding-left: .4rem;
      color: #333;
    }

    &:-ms-input-placeholder {
      padding-left: .4rem;
      color: #333;
    }
  }

  .last {
    margin-right: 0;
  }

  .active_input {
    border: 1px solid #e61717;
    color: #e61717;
  }

  .send_code {
    width: 3.3867rem;
    background: #fff;
    outline: 0;
    border: 0;
    margin-left: .5333rem;
    padding-left: .4rem;
    border-radius: .08rem 0 0 .08rem;
  }

  .send_code_tx {
    min-width: 3.0133rem;
    height: 1.28rem;
    background: #e8e8ed;
    line-height: 1.28rem;
    font-size: .3733rem;
    cursor: pointer;
    border-radius: 0 3px 3px 0;
    white-space: nowrap;
    text-align: center;
  }

  .active_c {
    color: #ccc;
  }

  .active_c1 {
    color: #e61717;
  }

  .try_button {
    color: #fff;
    font-size: .5333rem;
    text-align: center;
    line-height: 1.28rem;
    cursor: pointer;
    min-width: 3.7333rem;
    height: 1.28rem;
    background-color: #e61717;
    border-radius: .08rem;
    margin-left: .32rem;
    white-space: nowrap;
  }

  .bg_active0 {
    background: #e61717 !important;
  }

  .bg_active1 {
    background: rgba(230, 23, 23, 0.5) !important;
  }
}

@keyframes fadeOutDown {
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    transform: translate3d(-100%, 0, 0);
  }
}

.fadeOutDown {
  animation-name: fadeOutDown;
}

@keyframes fadeInUp {
  0% {
    transform: translate3d(-100%, 0, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}

.fadeInUp {
  animation-name: fadeInUp;
}

.animated {
  animation-duration: 0.4s;
  animation-fill-mode: both;
}
.pointer {
  pointer-events: none;
}

@media (print), (prefers-reduced-motion: reduce) {
  .animated {
    animation-duration: 1ms !important;
    transition-duration: 1ms !important;
    animation-iteration-count: 1 !important;
  }
}

/deep/ .nc_scale {
  border-radius: .08rem;

  .btn_ok {
    border-radius: 0 .08rem .08rem 0;
  }
}
  .scrollBanner {
    display: none;
  }
</style>

<style lang="less">
@import '../mixins/bot.less';

.scrollBanner {
  .bot_slide_pc(@slideHeight: 1.28rem, @slideWidth: 6.4rem, @containerMargin: 0 0 0 .32rem);
}
</style>
